













 












const node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DismissNewFeaturePayload",
    "kind": "LinkedField",
    "name": "dismissNewFeature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StandardMutationError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DismissNewFeatureMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DismissNewFeatureMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "m_OGS0fy9ckloemK6WqEmPjg",
    "metadata": {},
    "name": "DismissNewFeatureMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "ba52a4dd4d9db31377f3df849c5f5693";

export default node;
